import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";

import { timberBending } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function TimberBendingOblique({}) {
  const toast = useToast();
  // BENDING
  const [bendingObliqueInputs, setBendingObliqueInputs] = useState({
    forest_type: "Nativa",
    timber: "Coníferas",
    timber_class: "D20",
    timber_type: "Madeira serrada",
    load_class: "Permanente",
    moisture_class: "1 (≤ 65%)",
    l1_x: "",
    b: "",
    h: "",
    msd_x: "",
    msd_y: "",
  });
  const [bendingObliqueOutputs, setBendingObliqueOutputs] = useState({
    fm_d: "",
    tens_mx_d: "",
    tens_my_d: "",
    verification_x: "",
    verification_y: "",
    limit_1: "",
    limit_2: "",
    memorial: {},
  });

  function updateBendingObliqueInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class"
    ) {
      if (value === "Nativa") {
        setBendingObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setBendingObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setBendingObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setBendingObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setBendingObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setBendingObliqueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setBendingObliqueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setBendingObliqueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setBendingObliqueOutputs({
      fm_d: "",
      tens_mx_d: "",
      tens_my_d: "",
      verification_x: "",
      verification_y: "",
      limit_1: "",
      limit_2: "",
    });
  }

  function onBendingObliqueCalculate() {
    if (
      bendingObliqueInputs["l1_x"] === "" ||
      bendingObliqueInputs["b"] === "" ||
      bendingObliqueInputs["h"] === "" ||
      bendingObliqueInputs["msd_x"] === "" ||
      bendingObliqueInputs["msd_y"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      bendingObliqueInputs["l1_x"] === 0 ||
      bendingObliqueInputs["b"] === 0 ||
      bendingObliqueInputs["h"] === 0 ||
      bendingObliqueInputs["msd_x"] === 0 ||
      bendingObliqueInputs["msd_y"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberBending(bendingObliqueInputs).then((response) => {
        setBendingObliqueOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-bending-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page: "timber-bending-oblique-calculator",
    });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Flexão Simples Oblíqua:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) =>
                updateBendingObliqueInputs("forest_type", e.target.value)
              }
              value={bendingObliqueInputs["forest_type"]}
            />
            {bendingObliqueInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) =>
                  updateBendingObliqueInputs("timber", e.target.value)
                }
                value={bendingObliqueInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                bendingObliqueInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : bendingObliqueInputs["forest_type"] === "Plantada" &&
                      bendingObliqueInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : bendingObliqueInputs["forest_type"] === "Plantada" &&
                        bendingObliqueInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateBendingObliqueInputs("timber_class", e.target.value)
              }
              value={bendingObliqueInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateBendingObliqueInputs("moisture_class", e.target.value)
              }
              value={bendingObliqueInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingObliqueInputs("timber_type", e.target.value)
              }
              value={bendingObliqueInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingObliqueInputs("load_class", e.target.value)
              }
              value={bendingObliqueInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="L1"
              unit="cm"
              onChange={(e) =>
                updateBendingObliqueInputs("l1_x", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateBendingObliqueInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateBendingObliqueInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Msd,x"
              unit="tfm"
              onChange={(e) =>
                updateBendingObliqueInputs("msd_x", e.target.value)
              }
            />
            <InputNumber
              text="Msd,y"
              unit="tfm"
              onChange={(e) =>
                updateBendingObliqueInputs("msd_y", e.target.value)
              }
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onBendingObliqueCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          <Output
            text="fm,d"
            value={bendingObliqueOutputs["fm_d"]}
            unit="MPa"
          />
          <h4>Momento em torno do eixo X</h4>
          <Output
            text="σMx,d"
            value={bendingObliqueOutputs["tens_mx_d"]}
            unit="MPa"
          />
          {bendingObliqueOutputs["tens_mx_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingObliqueOutputs["tens_mx_d"].toFixed(2) +
                " ≤ " +
                bendingObliqueOutputs["fm_d"].toFixed(2) +
                " → "}
              {bendingObliqueOutputs["tens_mx_d"] <=
              bendingObliqueOutputs["fm_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Momento em torno do eixo Y</h4>
          <Output
            text="σMy,d"
            value={bendingObliqueOutputs["tens_my_d"]}
            unit="MPa"
          />
          {bendingObliqueOutputs["tens_my_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingObliqueOutputs["tens_my_d"].toFixed(2) +
                " ≤ " +
                bendingObliqueOutputs["fm_d"].toFixed(2) +
                " → "}
              {bendingObliqueOutputs["tens_my_d"] <=
              bendingObliqueOutputs["fm_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Flexão Simples Oblíqua</h4>
          {bendingObliqueOutputs["verification_x"] !== "" && (
            <>
              <h4 className={styles.rowDescription}>
                {bendingObliqueOutputs["verification_x"].toFixed(2) + " ≤ 1 → "}
                {bendingObliqueOutputs["verification_x"] <= 1
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
              <h4 className={styles.rowDescription}>
                {bendingObliqueOutputs["verification_y"].toFixed(2) + " ≤ 1 → "}
                {bendingObliqueOutputs["verification_y"] <= 1
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            </>
          )}
          <h4>Estabilidade lateral</h4>
          {bendingObliqueOutputs["tens_mx_d"] !== "" &&
            (bendingObliqueInputs["l1_x"] / bendingObliqueInputs["b"] <=
            bendingObliqueOutputs["limit_1"] ? (
              <h4 className={styles.rowDescription}>
                {(
                  bendingObliqueInputs["l1_x"] / bendingObliqueInputs["b"]
                ).toFixed(2) +
                  " ≤ " +
                  bendingObliqueOutputs["limit_1"].toFixed(2) +
                  " → OK!"}
              </h4>
            ) : (
              <h4 className={styles.rowDescription}>
                {bendingObliqueOutputs["tens_mx_d"].toFixed(2) +
                  " ≤ " +
                  bendingObliqueOutputs["limit_2"].toFixed(2) +
                  " → "}
                {bendingObliqueOutputs["tens_mx_d"] <=
                bendingObliqueOutputs["limit_2"]
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            ))}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {bendingObliqueOutputs["memorial"] &&
          Object.entries(bendingObliqueOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberBendingOblique;
